import React from 'react';

import { 
  makeStyles, 
  useTheme
} from '@material-ui/core/styles';

import { 
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
} from '@material-ui/core';

import {
  Build as BuildIcon,
  TrendingUp as TrendingUpIcon,
  Search as SearchIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root:{
    padding: 20
  },
  card: {
    width: '100%',
  },
  media: {
    height: 140,
  },
  feature: {
    textAlign: 'center'
  },
  featureHeading: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
  }
}));

const handleLogin = () => {
  window.location="https://login.nextcloud.aero?returnTo="+window.location.href;
};

export default function LandingPage() {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const iconSize = isSmall ? "small" : "large";
  
  return (
    <div className={classes.root}>
      <Card className={classes.card} >
        <CardHeader
          title="NEXT Data Lake Console"
          titleTypographyProps={{variant: 'h4'}}
          action={
          <Button variant="outlined" size="medium" color="primary" onClick={handleLogin}>
            Login
          </Button>
          }
        />
        <CardMedia
          className={classes.media}
          image="/datalake.jpg"
          title="Data Lake"
        />
        <CardContent>
          <Grid container spacing={isSmall ? 2 : 10}>
            <Grid item xs={12} sm={4} className={classes.feature}>
              <div className={classes.featureHeading}>
                <SearchIcon fontSize={iconSize}/>
                <Typography gutterBottom variant="h5" component="h2">
                  Manage
                </Typography>
              </div>
              <Typography variant="body2" color="textSecondary" component="p">
                Quickly locate and view the configuration and metrics of any of your Landing
                Zones, Datasets, Workloads or other resources deployed in the data lake 
                from any of your Next Cloud accounts. 
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} className={classes.feature}>
              <div className={classes.featureHeading}>
                <TrendingUpIcon fontSize={iconSize}/>
                <Typography gutterBottom variant="h5" component="h2">
                  Monitor
                </Typography>
              </div>
              <Typography variant="body2" color="textSecondary" component="p">
                Always get the lastest operational status, metrics and configuration
                changes to any of your data lake resources in real time as it happens.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} className={classes.feature}>
              <div className={classes.featureHeading}>
                <BuildIcon fontSize={iconSize}/>
                <Typography gutterBottom variant="h5" component="h2">
                  Maintain
                </Typography>
              </div>
              <Typography variant="body2" color="textSecondary" component="p">
                Maintain your workloads with ad-hoc executions, logs and monitoring 
                to help you quickly pinpoint issues, test updates and retry failed inputs.
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}